import { render, staticRenderFns } from "./columns-info.vue?vue&type=template&id=3bbe31ab&scoped=true"
import script from "./columns-info.vue?vue&type=script&lang=js"
export * from "./columns-info.vue?vue&type=script&lang=js"
import style0 from "./columns-info.vue?vue&type=style&index=0&id=3bbe31ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbe31ab",
  null
  
)

export default component.exports